import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { ActivationStatus } from '@super/shared-types'
import { useAppAuth } from '@/contexts/app-auth.context'
import { FeatureFlags } from '@/types/feature-flags'

interface ActivationGateProps {
  children: ReactNode
}

export function ActivationGate({ children }: ActivationGateProps) {
  const { activationStatus, featureFlags, isAppContextLoading, isInitialized } =
    useAppAuth()

  if (!isInitialized || isAppContextLoading) {
    return null
  }

  if (activationStatus === ActivationStatus.PENDING) {
    const canOnboard = featureFlags.includes(
      FeatureFlags.SELF_SERVICE_ONBOARDING,
    )
    return (
      <Navigate to={canOnboard ? '/onboarding/setup' : '/waitlist'} replace />
    )
  }

  return <>{children}</>
}
